import { AutenticacionService } from '../../../services/autenticacion.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-ticket-implementacion-modal',
  templateUrl: './ticket-implementaciones-modal.component.html',
  styleUrls: ['./ticket-implementaciones-modal.component.scss']
})
export class TicketImplementacionModalComponent implements OnInit {
  ngOnInit() {
  }

  reset() {
    this.close();
  }

  open() {
    $('#ticketImplementacionModal').modal('show');
  }

  close() {
    $('#ticketImplementacionModal').modal('hide');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-implementaciones-modal/ticket-implementaciones-modal.component.ts